import { render, staticRenderFns } from "./SettingActivitySwitchDialog.vue?vue&type=template&id=53d3ef22&scoped=true"
import script from "./SettingActivitySwitchDialog.vue?vue&type=script&lang=js"
export * from "./SettingActivitySwitchDialog.vue?vue&type=script&lang=js"
import style0 from "./SettingActivitySwitchDialog.vue?vue&type=style&index=0&id=53d3ef22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d3ef22",
  null
  
)

export default component.exports